import Platform from 'platform';

export default class UserAgent {
  static setBrowser(){
    $('html').attr({'data-browser-name':Platform.name,'data-browser-version':Platform.version});
  }
  static isMobile(){
    return Platform.name.match(/Mobile/i);
  }
}

UserAgent.setBrowser();
